import { FC } from "react";
import { Helmet } from "react-helmet-async";

type SchemaType =
  | "Organization"
  | "WebSite"
  | "WebPage"
  | "Article"
  | "BreadcrumbList"
  | "Product"
  | "FAQPage"
  | "Service"
  | "LocalBusiness"
  | "JobPosting"
  | "Event"
  | "VideoObject"
  | "SoftwareApplication";

interface JsonLdProps {
  type: SchemaType;
  data: Record<string, unknown>;
}

export const JsonLd: FC<JsonLdProps> = ({ type, data }) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": type,
    ...data,
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};
